import React, { useState } from 'react';
import { AddExpenseCategory } from '../../pages';
import * as yup from 'yup';
import constant from '../../utils/constant';
import { MimaToastUtil } from '../../components';
import { ExpenseCategoryController } from '../../controllers';

const AddExpenseCategoryContainer = ({closeModal, data}) => {
    const [loading, setLoading] = useState(false);
    const validationSchema = () => {
        return (
            yup.object().shape({
                name: yup.string().required("Enter category name"),   
                description: yup.string().max(50, "Characters should not be more than 50")       
            })
        )
    }

    const onSubmit = async (values) => {
        setLoading(true);
        const payload = {
            name: values.name, 
            description: values.description,                     
        }
        const { status, errorMessage } = await ExpenseCategoryController.createExpenseCategories(payload);

        if (status === constant.Success) {
            ExpenseCategoryController.getExpenseCategories();           
            MimaToastUtil.success({ message: constant.Success })          
           setLoading(false);
           return closeModal();
        }  else {
            setLoading(false);
            MimaToastUtil.error({ message: errorMessage })
        }
    }
    return (
        <AddExpenseCategory
        validationSchema={validationSchema}
        loading={loading}
        closeModal={closeModal}
        data={data}
        onSubmit={onSubmit}
        />
    )
}
export default AddExpenseCategoryContainer;